export const genitive = (str) => {
    return str ? str + (str.at(-1) === 's' ? `'` : 's') : '';
};
